const PropTypes = require('prop-types');
const React = require('react');
const { includes } = require('lodash');
const ScrollTarget = require('components/shared/scroll_target.jsx');
const ComparisonShoppingListingTab = require('./comparison_shopping_listing_tab.jsx');
const ListingTabContent = require('./listing_tab_content.jsx');
const Tabs = require('components/shared/tabs.jsx');
const PriceGuideChart = require('components/price_guide/transaction_history/chart.jsx');
const PriceGuideTable = require('components/price_guide/transaction_history/table.jsx');
const PriceRange = require('components/price_guide/transaction_history/price_range.jsx');
const ProductSpecsList = require('./product_specs_list.jsx');
const NoListingsTab = require('./no_listings_tab.jsx');
const { UserStore } = require('@reverbdotcom/discovery-ui');
const APIRequest = require('components/api_request.js');
const UrlHelpers = require('components/shared/url_helpers.js');
const { HashUtil, Tracker } = require('@reverbdotcom/discovery-ui');

const USED_CONDITION = 'used';
const NEW_CONDITION = 'new';

class ComparisonShoppingTabs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      trackedBumpForNewRowViewed: false,
      trackedNewTabViewed: false,
      newListingsViewed: false,
      loadChart: false,
    };

    this.priceHistoryTabDidShow = this.priceHistoryTabDidShow.bind(this);
  }

  componentDidMount() {
    $(document).on('click', '[data-show-comparison-shopping-tabs]', () => {
      this.scrollToTop();
    });
    this.fetchPriceRange();
  }

  get hasUsedProducts() {
    return this.props.usedCount > 0;
  }

  get hasNewProducts() {
    return this.props.newCount > 0;
  }

  get hasProducts() {
    return this.hasNewProducts || this.hasUsedProducts;
  }

  fetchPriceRange() {
    const url = UrlHelpers.comparisonShoppingPagePriceGuidePricesPath(
      this.props.comparisonShoppingPageId
    );

    APIRequest.V3.get(url).then((response) => {
      this.setState({
        retailBottom: response.retail_bottom,
        retailTop: response.retail_top,
      });
    });
  }

  scrollToTop() {
    this.refs.scrollTarget.scrollToTop();
  }

  priceHistoryTabDidShow() {
    // price guide chart does not render correctly when rendered while hidden, so
    // we need to re-render when shown
    if (this.state.loadChart === false) {
      this.setState({ loadChart: true });
    }
  }

  shouldRenderLearnMoreTab() {
    return this.hasDescription || this.hasProductSpecs;
  }

  shouldRenderPriceHistoryTab() {
    return this.state.retailBottom && this.state.retailTop;
  }

  get hasDescription() {
    return this.props.fullDescription && this.props.fullDescription.length > 0;
  }

  get hasProductSpecs() {
    return this.props.productSpecs && this.props.productSpecs.length > 0;
  }

  get retailBottomDisplayPrice() {
    return HashUtil.getSafely(this.state, 'retailBottom.display');
  }

  get retailTopDisplayPrice() {
    return HashUtil.getSafely(this.state, 'retailTop.display');
  }

  showLocalCallout() {
    return this.props.global && this.props.localLink;
  }

  showGlobalCallout() {
    return this.props.localeCallout && this.props.globalLink;
  }

  localeCallout() {
    let callout;
    const countryName = I18n.t(`countries.${UserStore.getState().countryCode}`);

    if (this.showLocalCallout()) {
      callout = I18n.t(
        'comparisonShoppingPage.localeCallout.global',
        {
          openLinkTag: `<a className="strong" href="${this.props.localLink}">`,
          closeLinkTag: '</a>',
          countryName,
        }
      );
    }

    if (this.showGlobalCallout()) {
      callout = I18n.t(
        'comparisonShoppingPage.localeCallout.local',
        {
          openLinkTag: `<a className="strong" href="${this.props.globalLink}">`,
          closeLinkTag: '</a>',
          countryName,
        }
      );
    }

    return callout;
  }

  get buyButtonListings() {
    return this.props.buyButtonListings;
  }

  trackView(name, ids) {
    Tracker.view({
      name,
      type: 'comparison_shopping_page',
      ids,
    });
  }

  trackNewListingsViewed(newListingIds) {
    if (!this.state.newListingsViewed) {
      this.setState({ newListingsViewed: true });
    }
    if (!this.state.trackedBumpForNewRowViewed) {
      this.trackView('BumpForNew', this.props.buyButtonListings);
      this.setState({ trackedBumpForNewRowViewed: true });
    }
    if (!this.state.trackedNewTabViewed && newListingIds) {
      this.trackView(
        'NonFeaturedListings',
        newListingIds.filter(id => !includes(this.buyButtonListings, id))
      );
      this.setState({ trackedNewTabViewed: true });
    }
  }

  newListingsLoaded(listingIds) {
    this.setState({ newListingIds: listingIds });
    if (this.state.newListingsViewed) {
      this.trackNewListingsViewed(listingIds);
    }
  }

  renderNoListingsTab() {
    if (this.hasProducts) { return null; }
    return (
      <Tabs.Tab name={this.renderNoListingsTabTitle()} id="listings">
        <NoListingsTab />
      </Tabs.Tab>
    );
  }

  renderNoListingsTabTitle() {
    return (
      <div>
        <div className="nav-tabs__tab__hydra-callout">
          {I18n.t('comparisonShoppingPage.listingTab.usedNew')}
        </div>
        <div className="show-only-on-desktop">
          {I18n.t('comparisonShoppingPage.listingTab.zeroListings')}
        </div>
      </div>
    );
  }

  renderUsedTab() {
    return (
      <Tabs.Tab name={this.renderUsedTabTitle()} id="used_listings">
        {this.renderLocaleCallout()}
        <ListingTabContent
          comparisonShoppingPageSlug={this.props.comparisonShoppingPageSlug}
          listingCondition={USED_CONDITION}
          scrollToTop={() => { this.scrollToTop(); }}
          searchParams={this.props.listingSearchParams}
        />
      </Tabs.Tab>
    );
  }

  renderUsedTabTitle() {
    return (
      <ComparisonShoppingListingTab
        listingCount={this.props.usedCount}
        lowPrice={this.props.usedLowPrice}
        listingCondition={USED_CONDITION}
      />
    );
  }

  renderLocaleCallout() {
    const calloutHTML = this.localeCallout();

    if (!calloutHTML) {
      return null;
    }

    return (
      <aside className="center size-120 ptb-1 plr-1 bg-white bd-1 bd--offwhite bd--dark mb-1">
        <p className="mb-0" dangerouslySetInnerHTML={{ __html: calloutHTML }}></p>
      </aside>
    );
  }

  renderNewTab() {
    return (
      <Tabs.Tab
        name={this.renderNewTabTitle()}
        id="new_listings"
        tabDidShow={() => this.trackNewListingsViewed(this.state.newListingIds)}
      >
        {this.renderLocaleCallout()}
        <ListingTabContent
          comparisonShoppingPageSlug={this.props.comparisonShoppingPageSlug}
          listingCondition={NEW_CONDITION}
          scrollToTop={() => { this.scrollToTop(); }}
          searchParams={this.props.listingSearchParams}
          buyButtonListings={this.buyButtonListings}
          listingsLoaded={(listingIds) => this.newListingsLoaded(listingIds)}
        />
      </Tabs.Tab>
    );
  }

  renderNewTabTitle() {
    return (
      <ComparisonShoppingListingTab
        listingCount={this.props.newCount}
        lowPrice={this.props.newLowPrice}
        listingCondition={NEW_CONDITION}
      />
    );
  }

  renderDescription() {
    if (this.props.fullDescription) {
      return (
        <article className="cms-text">
          <h3>{I18n.t('comparisonShoppingPage.productDescription')}</h3>
          <div
            dangerouslySetInnerHTML={{ __html: this.props.fullDescription }}
          />
        </article>
      );
    }
    return null;
  }

  renderLearnMoreTab() {
    return (
      <Tabs.Tab
        name={this.renderLearnMoreTabTitle()}
        id="learn_more"
      >
        {this.renderProductSpecs()}
        {this.renderDescription()}
      </Tabs.Tab>
    );
  }

  renderPriceHistoryTab() {
    return (
      <Tabs.Tab
        name={this.renderPriceHistoryTabTitle()}
        id="price_history"
        tabDidShow={this.priceHistoryTabDidShow}
      >
        {this.renderPriceGuideChart()}
        {this.renderPriceRange()}
        {this.renderTransactionHistoryTable()}
      </Tabs.Tab>
    );
  }

  renderPriceGuideChart() {
    return (
      <PriceGuideChart
        objectId={this.props.comparisonShoppingPageId}
        loadChart={this.state.loadChart}
        objectType="comparisonShoppingPage"
        ref="priceGuideChart"
      />
    );
  }

  renderPriceRange() {
    return (
      <PriceRange
        retailBottom={this.state.retailBottom}
        retailTop={this.state.retailTop}
      />
    );
  }

  renderTransactionHistoryTable() {
    return (
      <PriceGuideTable
        objectId={this.props.comparisonShoppingPageId}
        productTypeUuid={this.props.productTypeUuid}
        objectType="comparisonShoppingPage"
      />
    );
  }

  renderProductSpecs() {
    if (this.props.productSpecs && this.props.productSpecs.length > 0) {
      return (
        <ProductSpecsList productSpecs={this.props.productSpecs} />
      );
    }
    return null;
  }

  renderLearnMoreTabTitle() {
    return (
      <div>
        <div className="nav-tabs__tab__hydra-callout">
          {I18n.t('comparisonShoppingPage.learnMore')}
        </div>
        <div className="show-only-on-desktop">{I18n.t('comparisonShoppingPage.aboutProduct')}</div>
      </div>
    );
  }

  renderPriceHistoryTabTitle() {
    return (
      <div>
        <div className="nav-tabs__tab__hydra-callout">
          {I18n.t('comparisonShoppingPage.priceHistoryTab.priceHistory')}
        </div>
        <div className="show-only-on-desktop">
          {
            I18n.t(
              'comparisonShoppingPage.priceHistoryTab.priceRange',
              {
                lowPrice: this.retailBottomDisplayPrice,
                highPrice: this.retailTopDisplayPrice,
              }
            )
          }
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        <ScrollTarget ref="scrollTarget" />
        <Tabs
          className="hydra-tabs"
          updateUrlHash
        >
          {this.renderNoListingsTab()}
          {this.hasUsedProducts ? this.renderUsedTab() : null}
          {this.hasNewProducts ? this.renderNewTab() : null}
          {this.shouldRenderLearnMoreTab() ? this.renderLearnMoreTab() : null}
          {this.shouldRenderPriceHistoryTab() ? this.renderPriceHistoryTab() : null}
        </Tabs>
      </div>
    );
  }
}

ComparisonShoppingTabs.propTypes = {
  comparisonShoppingPageId: PropTypes.number.isRequired,
  comparisonShoppingPageSlug: PropTypes.string.isRequired,
  productTypeUuid: PropTypes.string,
  priceGuideId: PropTypes.number,
  usedCount: PropTypes.number.isRequired,
  usedLowPrice: PropTypes.string,
  newCount: PropTypes.number.isRequired,
  newLowPrice: PropTypes.string,
  productTitle: PropTypes.string.isRequired,
  productSpecs: PropTypes.array,
  fullDescription: PropTypes.string,
  showingBuyButton: PropTypes.bool,
  buyButtonListings: PropTypes.array,
  global: PropTypes.bool,
  globalLink: PropTypes.string,
  localeCallout: PropTypes.bool,
  localLink: PropTypes.string,
  listingSearchParams: PropTypes.object,
};

module.exports = ComparisonShoppingTabs;



// WEBPACK FOOTER //
// ./javascripts/components/comparison_shopping_page/comparison_shopping_tabs.jsx